import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/data/services";
import "./services.css";

export default function Services() {
  return (
    <div data-testid="services-page">
      {/* HEADER */}
      <section className="border-b border-black/10 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-20 relative">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF4F00] reveal-up">/ Services</p>
          <div className="grid grid-cols-12 gap-6 mt-6">
            <h1 className="font-display col-span-12 md:col-span-8 text-mega font-black tracking-tighter uppercase leading-[0.9] reveal-up">
              What we<br/>build, scale,<br/><span className="text-[#FF4F00]">and secure.</span>
            </h1>
            <div className="col-span-12 md:col-span-4 md:col-start-9 self-end reveal-up" style={{animationDelay: '.1s'}}>
              <p className="text-[#52525B] leading-relaxed">
                Six core disciplines, woven into squads sized to your stage. Pick a service or combine them — most engagements span engineering, design, and infrastructure.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES LIST */}
      <section className="border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-row-${s.id}`}
                className="group grid grid-cols-12 gap-6 py-12 md:py-16 border-b border-black/10 last:border-b-0 hover:bg-[#F4F4F5] transition-colors"
              >
                <div className="col-span-12 md:col-span-2">
                  <p className="font-display text-3xl font-black text-[#FF4F00]">0{idx + 1}</p>
                  <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#0A0A0A]/40 mt-2">/ Discipline</p>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 border border-black/20 inline-flex items-center justify-center group-hover:bg-[#0A0A0A] group-hover:text-white group-hover:border-[#0A0A0A] transition-colors">
                      <Icon size={22} weight="duotone" />
                    </div>
                    <h2 className="font-display text-2xl md:text-4xl font-extrabold tracking-tight uppercase">{s.title}</h2>
                  </div>
                  <p className="mt-6 text-[#52525B] text-base leading-relaxed max-w-2xl">{s.description}</p>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#0A0A0A]/40 mb-4">/ Deliverables</p>
                  <ul className="space-y-2">
                    {s.deliverables.map((d) => (
                      <li key={d} className="text-sm flex items-center gap-3">
                        <span className="inline-block w-2 h-2 bg-[#FF4F00]" />
                        {d}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" data-testid={`service-cta-${s.id}`} className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#0A0A0A] hover:text-[#FF4F00] link-underline">
                    Enquire <ArrowUpRight size={14} weight="bold" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
          <div className="grid grid-cols-12 gap-6 mb-12">
            <div className="col-span-12 md:col-span-6">
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF4F00]">/ Industries</p>
              <h2 className="font-display mt-4 text-4xl sm:text-5xl font-extrabold uppercase tracking-tight indust-heading">
                Where our squads operate.
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-black/10">
            {["Fintech","Healthcare","SaaS","E-commerce","Logistics","Media","EdTech","Climate"].map((i) => (
              <div key={i} className="bg-[#fff] p-8 hover:bg-white transition-colors">
                <p className="font-display text-xl font-bold uppercase tracking-tight">{i}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RIES ── --> */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <div>
              <p className="eyebrow">/ Industries</p>
              <h2 className="section-title display">Industries<br/>we serve</h2>
            </div>
            <div className="section-desc">
              We understand your industry and build solutions that fit your business model.
            </div>
          </div>
      
          <div className="industries-grid">
      
            {/* <!-- 1 — Salons (dark, wide) --> */}
            <a href="https://aura-salonspa.netlify.app" className="industry-card dark">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1560066984-138dadb4c035?w=900&q=80" alt="Salons & Spas" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">✂</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Salons &amp; Spas</h3>
                <p className="card-desc">Booking, offers, and on-brand visual galleries.</p>
                <p className="card-num">01 / 06</p>
              </div>
            </a>
      
            {/* <!-- 2 — Gyms --> */}
            <a href="https://gymironfit.netlify.app/" className="industry-card">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=700&q=80" alt="Gyms & Fitness" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">⚡</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Gyms &amp; Fitness</h3>
                <p className="card-desc">Listings, agent profiles, and high-quality lead forms.</p>
                <p className="card-num">02 / 06</p>
              </div>
            </a>
      
            {/* <!-- 3 — Restaurants --> */}
            <a href="#" className="industry-card">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1552566626-52f8b828add9?w=700&q=80" alt="Restaurants & Cafes" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">🍽</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Restaurants &amp; Cafes</h3>
                <p className="card-desc">Menus, reservations, promotions and online ordering.</p>
                <p className="card-num">03 / 06</p>
              </div>
            </a>
      
            {/* <!-- 4 — Clinics (dark, wide) --> */}
            <a href="#" className="industry-card dark">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=900&q=80" alt="Clinics" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">＋</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Clinics</h3>
                <p className="card-desc">Doctor profiles, treatments and appointment requests.</p>
                <p className="card-num">04 / 06</p>
              </div>
            </a>
      
            {/* <!-- 5 — Real Estate --> */}
            <a href="#" className="industry-card">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=700&q=80" alt="Real Estate" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">🏠</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Real Estate</h3>
                <p className="card-desc">Listings, agent profiles, and high-quality lead forms.</p>
                <p className="card-num">05 / 06</p>
              </div>
            </a>
      
            {/* <!-- 6 — Cleaning --> */}
            <a href="#" className="industry-card">
              <div className="card-img">
                <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=700&q=80" alt="Cleaning Services" />
              </div>
              <div className="card-body">
                <div className="card-top">
                  <div className="card-icon">✦</div>
                  <span className="card-arrow">↗</span>
                </div>
                <h3 className="card-title display">Cleaning Services</h3>
                <p className="card-desc">Service packages, quote requests and local area pages.</p>
                <p className="card-num">06 / 06</p>
              </div>
            </a>
      
          </div>
        </div>
      </section>
      
      {/* ── WHY CHOOSE US + PROJECT STYLES ── */}
      <section className="section">
        <div className="container">
          <div className="why-grid">
      
            {/* <!-- Left --> */}
            <div className="why-left">
              <p className="eyebrow">/ Why Choose Us</p>
              <h2 className="section-title display">Premium design with<br/>practical business<br/>execution</h2>
              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-dot"></div>
                  <div>
                    <p className="feature-title">Business-focused approach</p>
                    <p className="feature-desc">We build solutions that solve real business problems.</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-dot"></div>
                  <div>
                    <p className="feature-title">Modern and scalable solutions</p>
                    <p className="feature-desc">Customisable technology that grows with your business.</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-dot"></div>
                  <div>
                    <p className="feature-title">Dedicated support</p>
                    <p className="feature-desc">Before launch, during launch and after launch.</p>
                  </div>
                </div>
              </div>
            </div>
      
            {/* <!-- Right --> */}
            <div className="why-right">
              <p className="why-right-label">/ Recent Work</p>
              <h3 className="display">Project styles</h3>
              <div className="projects-grid">
                <div className="project-card">
                  <a href="https://aura-salonspa.netlify.app/#" target="_blank" rel="noopener noreferrer">
                    <img src="https://images.unsplash.com/photo-1562322140-8baeececf3df?w=500&q=80" alt="aura-salonspa" />
                    <div className="project-label">
                      <p className="project-name">aura-salonspa</p>
                      <p className="project-type">Website Design &amp; Development</p>
                    </div>
                  </a>
                </div>
                <div className="project-card">
                  <a href="https://gymironfit.netlify.app/" target="_blank" rel="noopener noreferrer">
                    <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=500&q=80" alt="Gym ironfit" />
                    <div className="project-label">
                      <p className="project-name">Gym ironfit</p>
                      <p className="project-type">Membership Website</p>
                    </div>
                  </a>
                </div>
                <div className="project-card">
                  <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=500&q=80" alt="Urban Bites Cafe" />
                  <div className="project-label">
                    <p className="project-name">Urban Bites Cafe</p>
                    <p className="project-type">Website &amp; Online Ordering</p>
                  </div>
                </div>
                <div className="project-card">
                  <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=500&q=80" alt="Medicure Clinic" />
                  <div className="project-label">
                    <p className="project-name">Medicure Clinic</p>
                    <p className="project-type">Booking System</p>
                  </div>
                </div>
              </div>
            </div>
      
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0A0A0A] text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-display text-5xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
              Pick a service.<br/>Or pick all six.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <Link to="/contact" data-testid="services-cta-button" className="inline-flex items-center gap-3 bg-[#FF4F00] px-8 py-5 text-sm font-bold uppercase tracking-[0.2em] hover:bg-[#E64700]">
              Talk to a Squad Lead <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
      
      {/* ── PRICING ── */}
      <section className="section pricing-section">
        <div className="container">
          <div className="pricing-header">
            <div className="pricing-header-inner">
              <p className="eyebrow">/ Pricing</p>
              <h2 className="display">Simple, transparent pricing</h2>
            </div>
            <p>Choose a plan that fits your needs. All plans include consultation and clear deliverables.</p>
          </div>
      
          <div className="pricing-grid">
      
            {/* <!-- Starter --> */}
            <div className="plan">
              <p className="plan-name">Starter</p>
              <div className="plan-price display"><span className="plan-currency">₹</span> 69,999</div>
              <p className="plan-desc">Ideal for small businesses getting started.</p>
              <hr className="plan-divider" />
              <ul className="plan-features">
                <li>5-page website</li>
                <li>Responsive design</li>
                <li>Basic SEO</li>
                <li>Contact form</li>
              </ul>
              <a href="#" className="plan-btn">View Plan</a>
            </div>
      
            {/* <!-- Business (Featured) --> */}
            <div className="plan featured">
              <span className="plan-badge">Most Popular</span>
              <p className="plan-name">Business</p>
              <div className="plan-price display"><span className="plan-currency">₹</span> 1,14,999</div>
              <p className="plan-desc">Perfect for growing businesses.</p>
              <hr className="plan-divider" />
              <ul className="plan-features">
                <li>Up to 10 pages</li>
                <li>Advanced SEO</li>
                <li>WhatsApp integration</li>
                <li>1-week support</li>
              </ul>
              <a href="#" className="plan-btn">View Plan</a>
            </div>
      
            {/* <!-- Premium --> */}
            <div className="plan">
              <p className="plan-name">Premium</p>
              <div className="plan-price display"><span className="plan-currency">₹</span> 1,84,999</div>
              <p className="plan-desc">For businesses that need more.</p>
              <hr className="plan-divider" />
              <ul className="plan-features">
                <li>Advanced features</li>
                <li>Booking/e-commerce</li>
                <li>Custom UI sections</li>
                <li>3 months support</li>
              </ul>
              <a href="#" className="plan-btn">View Plan</a>
            </div>
      
          </div>
        </div>
      </section>
      
      {/* <!-- ── CTA AUDIT BANNER ── --> */}
      <div className="text-white" style={{background: 'rgb(244 244 245 / var(--tw-bg-opacity, 1))', color: '#000'}}>
        <div className="cta-banner">
          <div>
            <p className="cta-eyebrow">/ Free Audit</p>
            <h2 className="cta-title display">Get your free<br/>website audit today</h2>
            <p className="cta-desc">We'll review your website, identify opportunities and provide actionable recommendations to help you grow online.</p>
            <a href="#" className="cta-btn">Request Free Audit →</a>
          </div>
          <div className="cta-right">
            <p className="cta-audit-label">What you'll get</p>
            <p>
              A detailed breakdown of your current website's performance, SEO health, design quality, and conversion potential — delivered within 48 hours, at no cost.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
